webpackJsonp([19],{

/***/ "./node_modules/ngx-auth/ngx-auth.es5.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ɵa */
/* unused harmony export AuthService */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PublicGuard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ProtectedGuard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PUBLIC_FALLBACK_PAGE_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROTECTED_FALLBACK_PAGE_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AuthModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_first__ = __webpack_require__("./node_modules/rxjs/operator/first.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_switchMap__ = __webpack_require__("./node_modules/rxjs/operator/switchMap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__("./node_modules/rxjs/operator/map.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_catch__ = __webpack_require__("./node_modules/rxjs/operator/catch.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_throw__ = __webpack_require__("./node_modules/rxjs/observable/throw.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_observable_throw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_throw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__angular_common_http__ = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Subject__ = __webpack_require__("./node_modules/rxjs/Subject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_Subject__);









/**
 * Essential service for authentication
 * @export
 * @interface AuthService
 */
var AuthService = (function () {
    function AuthService() {
    }
    return AuthService;
}());
function first$2(obs) {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_first__["first"].call(obs);
}
function switchMap$2(obs, project) {
    return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_switchMap__["switchMap"].call(obs, project);
}
function map$2(obs, project) {
    return __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(obs, project);
}
function _catch$2(obs, selector) {
    return __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_catch__["_catch"].call(obs, selector);
}
var AUTH_SERVICE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('AUTH_SERVICE');
var PUBLIC_FALLBACK_PAGE_URI = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('PUBLIC_FALLBACK_PAGE_URI');
var PROTECTED_FALLBACK_PAGE_URI = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('PROTECTED_FALLBACK_PAGE_URI');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); };
};
/**
 * Guard, checks access token availability and allows or disallows access to page,
 * and redirects out
 *
 * usage: { path: 'test', component: TestComponent, canActivate: [ PublicGuard ] }
 *
 * @export
 *
 * @class PublicGuard
 *
 * @implements {CanActivate}
 * @implements {CanActivateChild}
 */
var PublicGuard = (function () {
    function PublicGuard(authService, protectedFallbackPageUri, router$$1) {
        this.authService = authService;
        this.protectedFallbackPageUri = protectedFallbackPageUri;
        this.router = router$$1;
    }
    /**
     * CanActivate handler
     *
     * @param {ActivatedRouteSnapshot} _route
     * @param {RouterStateSnapshot} state
     *
     * @returns {Observable<boolean>}
     */
    PublicGuard.prototype.canActivate = function (_route, state) {
        var _this = this;
        return map$2(this.authService.isAuthorized(), function (isAuthorized) {
            if (isAuthorized && !_this.isProtectedPage(state)) {
                _this.navigate(_this.protectedFallbackPageUri);
                return false;
            }
            return true;
        });
    };
    /**
     * CanActivateChild handler
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     *
     * @returns {Observable<boolean>}
     */
    PublicGuard.prototype.canActivateChild = function (route, state) {
        return this.canActivate(route, state);
    };
    /**
     * Check, if current page is protected fallback page
     *
     * @private
     *
     * @param {RouterStateSnapshot} state
     *
     * @returns {boolean}
     */
    PublicGuard.prototype.isProtectedPage = function (state) {
        return state.url === this.protectedFallbackPageUri;
    };
    /**
     * Navigate away from the app / path
     *
     * @private
     * @param {string} url
     */
    PublicGuard.prototype.navigate = function (url) {
        if (url.startsWith('http')) {
            window.location.href = url;
        }
        else {
            this.router.navigateByUrl(url);
        }
    };
    return PublicGuard;
}());
PublicGuard = __decorate([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __param(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(AUTH_SERVICE)),
    __param(1, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(PROTECTED_FALLBACK_PAGE_URI)),
    __metadata("design:paramtypes", [AuthService, String, __WEBPACK_IMPORTED_MODULE_1__angular_router__["d" /* Router */]])
], PublicGuard);
var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(k, v);
};
var __param$1 = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); };
};
/**
 * Guard, checks access token availability and allows or disallows access to page,
 * and redirects out
 *
 * usage: { path: 'test', component: TestComponent, canActivate: [ AuthGuard ] }
 *
 * @export
 *
 * @class ProtectedGuard
 *
 * @implements {CanActivate}
 * @implements {CanActivateChild}
 */
var ProtectedGuard = (function () {
    function ProtectedGuard(authService, publicFallbackPageUri, router$$1) {
        this.authService = authService;
        this.publicFallbackPageUri = publicFallbackPageUri;
        this.router = router$$1;
    }
    /**
     * CanActivate handler
     *
     * @param {ActivatedRouteSnapshot} _route
     * @param {RouterStateSnapshot} state
     *
     * @returns {Observable<boolean>}
     */
    ProtectedGuard.prototype.canActivate = function (_route, state) {
        var _this = this;
        return map$2(this.authService.isAuthorized(), function (isAuthorized) {
            if (!isAuthorized && !_this.isPublicPage(state)) {
                _this.navigate(_this.publicFallbackPageUri);
                return false;
            }
            return true;
        });
    };
    /**
     * CanActivateChild handler
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     *
     * @returns {Observable<boolean>}
     */
    ProtectedGuard.prototype.canActivateChild = function (route, state) {
        return this.canActivate(route, state);
    };
    /**
     * Check, if current page is public fallback page
     *
     * @private
     *
     * @param {RouterStateSnapshot} state
     *
     * @returns {boolean}
     */
    ProtectedGuard.prototype.isPublicPage = function (state) {
        return state.url === this.publicFallbackPageUri;
    };
    /**
     * Navigate away from the app / path
     *
     * @private
     * @param {string} url
     */
    ProtectedGuard.prototype.navigate = function (url) {
        if (url.startsWith('http')) {
            window.location.href = url;
        }
        else {
            this.router.navigateByUrl(url);
        }
    };
    return ProtectedGuard;
}());
ProtectedGuard = __decorate$1([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __param$1(0, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(AUTH_SERVICE)),
    __param$1(1, Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"])(PUBLIC_FALLBACK_PAGE_URI)),
    __metadata$1("design:paramtypes", [AuthService, String, __WEBPACK_IMPORTED_MODULE_1__angular_router__["d" /* Router */]])
], ProtectedGuard);
var __decorate$3 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$2 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(k, v);
};
var AuthInterceptor = (function () {
    function AuthInterceptor(injector) {
        this.injector = injector;
        /**
         * Is refresh token is being executed
         *
         * @private
         *
         * @type {boolean}
         */
        this.refreshInProgress = false;
        /**
         * Notify all outstanding requests through this subject
         *
         * @private
         *
         * @type {Subject<boolean>}
         */
        this.refreshSubject = new __WEBPACK_IMPORTED_MODULE_8_rxjs_Subject__["Subject"]();
    }
    /**
     * Intercept an outgoing `HttpRequest`
     *
     * @param {HttpRequest<*>} req
     * @param {HttpHandler} delegate
     *
     * @returns {Observable<HttpEvent<*>>}
     */
    AuthInterceptor.prototype.intercept = function (req, delegate) {
        var authService = this.injector.get(AUTH_SERVICE);
        if (authService.verifyTokenRequest(req.url)) {
            return delegate.handle(req);
        }
        return this.processIntercept(req, delegate);
    };
    /**
     * Process all the requests via custom interceptors.
     *
     * @private
     *
     * @param {HttpRequest<*>} original
     * @param {HttpHandler} delegate
     *
     * @returns {Observable<HttpEvent<*>>}
     */
    AuthInterceptor.prototype.processIntercept = function (original, delegate) {
        var _this = this;
        var clone = original.clone();
        return _catch$2(switchMap$2(this.request(clone), function (req) { return delegate.handle(req); }), function (res) { return _this.responseError(clone, res); });
    };
    /**
     * Request interceptor. Delays request if refresh is in progress
     * otherwise adds token to the headers
     *
     * @private
     *
     * @param {HttpRequest<*>} req
     *
     * @returns {Observable}
     */
    AuthInterceptor.prototype.request = function (req) {
        if (this.refreshInProgress) {
            return this.delayRequest(req);
        }
        return this.addToken(req);
    };
    /**
     * Failed request interceptor, check if it has to be processed with refresh
     *
     * @private
     *
     * @param {HttpRequest<*>} req
     * @param {HttpErrorResponse} res
     *
     * @returns {Observable<HttpRequest<*>>}
     */
    AuthInterceptor.prototype.responseError = function (req, res) {
        var _this = this;
        var authService = this.injector.get(AUTH_SERVICE);
        var refreshShouldHappen = authService.refreshShouldHappen(res);
        if (refreshShouldHappen && !this.refreshInProgress) {
            this.refreshInProgress = true;
            authService
                .refreshToken()
                .subscribe(function () {
                _this.refreshInProgress = false;
                _this.refreshSubject.next(true);
            }, function () {
                _this.refreshInProgress = false;
                _this.refreshSubject.next(false);
            });
        }
        if (refreshShouldHappen && this.refreshInProgress) {
            return this.delayRequest(req, res);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_throw__["_throw"])(res);
    };
    /**
     * Add access token to headers or the request
     *
     * @private
     *
     * @param {HttpRequest<*>} req
     *
     * @returns {Observable<HttpRequest<*>>}
     */
    AuthInterceptor.prototype.addToken = function (req) {
        var authService = this.injector.get(AUTH_SERVICE);
        return first$2(map$2(authService.getAccessToken(), function (token) {
            if (token) {
                var headers = void 0;
                if (typeof authService.getHeaders === 'function') {
                    headers = authService.getHeaders(token);
                }
                else {
                    headers = { Authorization: "Bearer " + token };
                }
                return req.clone({
                    setHeaders: headers
                });
            }
            return req;
        }));
    };
    /**
     * Delay request, by subscribing on refresh event, once it finished, process it
     * otherwise throw error
     *
     * @private
     *
     * @param {HttpRequest<*>} req
     * @param {HttpErrorResponse} [res]
     *
     * @returns {Observable<HttpRequest<*>>}
     */
    AuthInterceptor.prototype.delayRequest = function (req, res) {
        var http$$1 = this.injector.get(__WEBPACK_IMPORTED_MODULE_7__angular_common_http__["b" /* HttpClient */]);
        return switchMap$2(first$2(this.refreshSubject), function (status) {
            if (status) {
                return http$$1.request(req);
            }
            return Object(__WEBPACK_IMPORTED_MODULE_6_rxjs_observable_throw__["_throw"])(res || req);
        });
    };
    return AuthInterceptor;
}());
AuthInterceptor = __decorate$3([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"])(),
    __metadata$2("design:paramtypes", [__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"]])
], AuthInterceptor);
var __decorate$2 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if (d = decorators[i])
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AuthModule = (function () {
    function AuthModule() {
    }
    return AuthModule;
}());
AuthModule = __decorate$2([
    Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
        providers: [
            PublicGuard,
            ProtectedGuard,
            AuthInterceptor,
            {
                provide: __WEBPACK_IMPORTED_MODULE_7__angular_common_http__["a" /* HTTP_INTERCEPTORS */],
                useClass: AuthInterceptor,
                multi: true,
            }
        ]
    })
], AuthModule);
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=ngx-auth.es5.js.map


/***/ }),

/***/ "./node_modules/rxjs/observable/ErrorObservable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ErrorObservable = (function (_super) {
    __extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */
    ErrorObservable.create = function (error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function (arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    ErrorObservable.prototype._subscribe = function (subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) {
            return scheduler.schedule(ErrorObservable.dispatch, 0, {
                error: error, subscriber: subscriber
            });
        }
        else {
            subscriber.error(error);
        }
    };
    return ErrorObservable;
}(Observable_1.Observable));
exports.ErrorObservable = ErrorObservable;
//# sourceMappingURL=ErrorObservable.js.map

/***/ }),

/***/ "./node_modules/rxjs/observable/throw.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ErrorObservable_1 = __webpack_require__("./node_modules/rxjs/observable/ErrorObservable.js");
exports._throw = ErrorObservable_1.ErrorObservable.create;
//# sourceMappingURL=throw.js.map

/***/ }),

/***/ "./src/app/core/core.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CoreModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common_http__ = __webpack_require__("./node_modules/@angular/common/esm5/http.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ngx_auth__ = __webpack_require__("./node_modules/ngx-auth/ngx-auth.es5.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__("./src/app/core/data/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services__ = __webpack_require__("./src/app/core/services/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tokens__ = __webpack_require__("./src/app/core/tokens.ts");
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var CoreModule = /** @class */ (function () {
    function CoreModule() {
    }
    CoreModule_1 = CoreModule;
    CoreModule.forChild = function (scopeKey) {
        return {
            ngModule: CoreModule_1,
            providers: [
                {
                    provide: __WEBPACK_IMPORTED_MODULE_5__tokens__["a" /* SCOPE_KEY */],
                    useValue: scopeKey,
                },
            ],
        };
    };
    CoreModule = CoreModule_1 = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_2_ngx_auth__["b" /* AuthModule */],
                __WEBPACK_IMPORTED_MODULE_0__angular_common_http__["c" /* HttpClientModule */],
            ],
            providers: [
                __WEBPACK_IMPORTED_MODULE_3__data__["a" /* AbnService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["b" /* AdminService */],
                __WEBPACK_IMPORTED_MODULE_4__services__["a" /* AuthService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["d" /* ClientService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["c" /* ClientResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["j" /* CustomerService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["i" /* CustomerResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["e" /* CommandService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["f" /* CommunicationPartialResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["g" /* CommunicationService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["h" /* CommunicationTemplateResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["l" /* DebtService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["k" /* DebtResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["m" /* DirectAuthService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["r" /* LogService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["n" /* FeeService */],
                __WEBPACK_IMPORTED_MODULE_4__services__["b" /* GoogleMapsService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["o" /* GuestUserService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["q" /* InvoiceService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["p" /* ImportService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["s" /* NoteService */],
                __WEBPACK_IMPORTED_MODULE_4__services__["c" /* PasswordService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["u" /* PaymentService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["v" /* PayrunService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["w" /* PermissionResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["x" /* PermissionService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["z" /* PromotionCodeService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["y" /* PromotionCodeResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["A" /* ReportService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["B" /* RoleResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["C" /* RoleService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["D" /* SlodService */],
                __WEBPACK_IMPORTED_MODULE_4__services__["d" /* SessionService */],
                __WEBPACK_IMPORTED_MODULE_4__services__["e" /* StorageService */],
                __WEBPACK_IMPORTED_MODULE_4__services__["f" /* TitleSetterService */],
                __WEBPACK_IMPORTED_MODULE_4__services__["g" /* TokenService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["G" /* TransactionService */],
                __WEBPACK_IMPORTED_MODULE_3__data__["F" /* TransactionResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["H" /* UserResolver */],
                __WEBPACK_IMPORTED_MODULE_3__data__["I" /* UserService */],
                {
                    provide: __WEBPACK_IMPORTED_MODULE_2_ngx_auth__["a" /* AUTH_SERVICE */],
                    useExisting: __WEBPACK_IMPORTED_MODULE_4__services__["g" /* TokenService */],
                },
            ],
        })
    ], CoreModule);
    return CoreModule;
    var CoreModule_1;
}());



/***/ }),

/***/ "./src/app/core/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_module__ = __webpack_require__("./src/app/core/core.module.ts");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__core_module__["a"]; });



/***/ }),

/***/ "./src/app/marketing/marketing.module.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MarketingModule", function() { return MarketingModule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("./node_modules/@angular/core/esm5/core.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_router__ = __webpack_require__("./node_modules/@angular/router/esm5/router.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared__ = __webpack_require__("./src/app/shared/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core__ = __webpack_require__("./src/app/core/index.ts");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__("./src/app/marketing/index.ts");
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var routes = [
    {
        path: 'cciq',
        component: __WEBPACK_IMPORTED_MODULE_4____["b" /* CCIQComponent */]
    },
    {
        path: 'mpaq',
        component: __WEBPACK_IMPORTED_MODULE_4____["i" /* MPAQComponent */]
    },
    {
        path: '',
        component: __WEBPACK_IMPORTED_MODULE_4____["h" /* LayoutComponent */],
        children: [
            {
                path: '',
                pathMatch: 'full',
                component: __WEBPACK_IMPORTED_MODULE_4____["f" /* HomeComponent */]
            },
            {
                path: 'about',
                component: __WEBPACK_IMPORTED_MODULE_4____["a" /* AboutComponent */]
            },
            {
                path: 'pricing',
                component: __WEBPACK_IMPORTED_MODULE_4____["j" /* PricingComponent */]
            },
            {
                path: 'faq',
                component: __WEBPACK_IMPORTED_MODULE_4____["e" /* FaqComponent */]
            },
            {
                path: 'contact',
                component: __WEBPACK_IMPORTED_MODULE_4____["c" /* ContactComponent */]
            },
            {
                path: 'how-it-works',
                component: __WEBPACK_IMPORTED_MODULE_4____["g" /* HowItWorksComponent */]
            },
            {
                path: 'privacy',
                component: __WEBPACK_IMPORTED_MODULE_4____["k" /* PrivacyComponent */]
            },
            {
                path: 'terms',
                component: __WEBPACK_IMPORTED_MODULE_4____["l" /* TermsComponent */]
            },
        ]
    }
];
var MarketingModule = /** @class */ (function () {
    function MarketingModule() {
    }
    MarketingModule = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({
            imports: [
                __WEBPACK_IMPORTED_MODULE_1__angular_router__["e" /* RouterModule */].forChild(routes),
                __WEBPACK_IMPORTED_MODULE_3__core__["a" /* CoreModule */].forChild('home'),
                __WEBPACK_IMPORTED_MODULE_2__shared__["a" /* SharedModule */],
            ],
            declarations: [
                __WEBPACK_IMPORTED_MODULE_4____["a" /* AboutComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["b" /* CCIQComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["i" /* MPAQComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["c" /* ContactComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["e" /* FaqComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["f" /* HomeComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["g" /* HowItWorksComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["h" /* LayoutComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["j" /* PricingComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["k" /* PrivacyComponent */],
                __WEBPACK_IMPORTED_MODULE_4____["l" /* TermsComponent */],
            ],
        })
    ], MarketingModule);
    return MarketingModule;
}());



/***/ })

});


// WEBPACK FOOTER //
// 19.chunk.7e440b5f6ddc.js